import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Separator.module.css';
export const Separator = forwardRef(function Separator({ orientation = 'horizontal', className, ...rest }, ref) {
    const classes = [
        styles.root,
        orientation === 'vertical' ? styles.vertical : styles.horizontal,
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("div", { ...rest, ref: ref, role: "separator", "aria-orientation": orientation, className: classes }));
});
//# sourceMappingURL=Separator.js.map